const ProgressBar = ({ nowProcess }) => {
  return (
    <div className="progress mb-5 d-none d-md-flex" style={{ height: '30px' }}>
      <div
        className="progress-bar bg-custom-color"
        role="progressbar"
        style={{
          width: '25%',
        }}
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        약관 동의
      </div>
      <div className="arrow-in-level"></div>
      <div
        className={`progress-bar rounded-start ${
          nowProcess >= 2 ? 'bg-custom-color' : 'bg-secondary'
        }`}
        role="progressbar"
        style={{
          width: '25%',
          overflow: 'hidden',
        }}
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        정보 입력
      </div>
      <div
        className={`${nowProcess >= 2 ? 'arrow-in-level' : 'arrow-in-normal'}`}
      ></div>
      <div
        className={`progress-bar rounded-start ${
          nowProcess >= 3 ? 'bg-custom-color' : 'bg-secondary'
        }`}
        role="progressbar"
        style={{
          width: '25%',
          overflow: 'hidden',
        }}
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        접수 확인 및 결제
      </div>
      <div
        className={`${nowProcess >= 3 ? 'arrow-in-level' : 'arrow-in-normal'}`}
      ></div>
      <div
        className={`progress-bar rounded-start ${
          nowProcess >= 4 ? 'bg-custom-color' : 'bg-secondary'
        }`}
        role="progressbar"
        style={{
          width: '25%',
          overflow: 'hidden',
        }}
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        결제 확인 및 주의사항
      </div>
      <div
        className={`${nowProcess >= 4 ? 'arrow-in-level' : 'arrow-in-normal'}`}
      ></div>
    </div>
  );
};
export default ProgressBar;
